import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import { CheckCircleFill, CloseCircleFill, InformationCircleFill, ClockCircleFill, ExclamationCircleFill } from 'antd-mobile-icons';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { isNodeWithContent } from '../../utils/is-node-with-content';
import Button from '../button';
var classPrefix = "adm-result-page";
var iconRecord = {
  success: CheckCircleFill,
  error: CloseCircleFill,
  info: InformationCircleFill,
  waiting: ClockCircleFill,
  warning: ExclamationCircleFill
};
var defaultProps = {
  status: 'info',
  details: []
};
export var ResultPage = function ResultPage(p) {
  var props = mergeProps(defaultProps, p);
  var status = props.status,
      title = props.title,
      description = props.description,
      details = props.details,
      icon = props.icon,
      primaryButtonText = props.primaryButtonText,
      secondaryButtonText = props.secondaryButtonText,
      onPrimaryButtonClick = props.onPrimaryButtonClick,
      onSecondaryButtonClick = props.onSecondaryButtonClick;
  var resultIcon = icon || React.createElement(iconRecord[status]);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      collapse = _useState2[0],
      setCollapse = _useState2[1];

  var showSecondaryButton = isNodeWithContent(secondaryButtonText);
  var showPrimaryButton = isNodeWithContent(primaryButtonText);
  return withNativeProps(props, React.createElement("div", {
    className: classPrefix
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-header")
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-icon")
  }, resultIcon), React.createElement("div", {
    className: "".concat(classPrefix, "-title")
  }, title), isNodeWithContent(description) ? React.createElement("div", {
    className: "".concat(classPrefix, "-description")
  }, description) : null, details.length ? React.createElement("div", {
    className: "".concat(classPrefix, "-details")
  }, (collapse ? details.slice(0, 3) : details).map(function (detail, index) {
    return React.createElement("div", {
      className: classNames("".concat(classPrefix, "-detail"), detail.bold && "".concat(classPrefix, "-detail-bold")),
      key: index
    }, React.createElement("span", null, detail.label), React.createElement("span", null, detail.value));
  }), details.length > 3 && React.createElement("div", {
    onClick: function onClick() {
      return setCollapse(function (prev) {
        return !prev;
      });
    }
  }, React.createElement("div", {
    className: classNames("".concat(classPrefix, "-collapse"), !collapse && "".concat(classPrefix, "-collapse-active"))
  }))) : null, React.createElement("div", {
    className: "".concat(classPrefix, "-bgWrapper")
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-bg")
  }))), React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, props.children), React.createElement("div", {
    className: "".concat(classPrefix, "-footer")
  }, showSecondaryButton && React.createElement(Button, {
    block: true,
    color: 'default',
    fill: 'solid',
    size: 'large',
    onClick: onSecondaryButtonClick,
    className: "".concat(classPrefix, "-footer-btn")
  }, secondaryButtonText), showPrimaryButton && showSecondaryButton && React.createElement("div", {
    className: "".concat(classPrefix, "-footer-space")
  }), showPrimaryButton && React.createElement(Button, {
    block: true,
    color: 'primary',
    fill: 'solid',
    size: 'large',
    onClick: onPrimaryButtonClick,
    className: "".concat(classPrefix, "-footer-btn")
  }, primaryButtonText))));
};